export const SET_AUTH_MODAL = 'ui/SET_AUTH_MODAL'
export const SET_HEADER_DARK = 'ui/SET_HEADER_DARK'
export const SET_NOT_FOUND = 'ui/SET_NOT_FOUND'

export const AUTH_MODAL_STATE = {
  SIGNIN: 'signIn',
  SIGNUP: 'signUp',
  FORGOT_PASSWORD: 'forgotPassword',
}
